@if (deviceSize$ | async; as deviceSize) {
  <mat-dialog-content class="" [ngClass]="{ mobile: deviceSize.isMobile }">
    <div class="position-relative">
      <button class="close-icon" (click)="close()">
        <img src="assets/glyphs/new-design/partner-app/close.svg" alt="close" />
      </button>
      <div class="custom-row w-100 align-items-center justify-space-between flex-no-wrap py-xx-large px-x-large">
        <div class="w-40 custom-column align-items-center">
          <img src="assets/glyphs/new-design/instadesk/icon.svg" alt="icon" class="icon" />
        </div>
        <div class="custom-column w-60">
          <img
            src="assets/glyphs/new-design/instadesk/instadesk-logo.svg"
            alt="InstaDesk logo"
            class="instadesk-logo"
          />
          <p class="f-24 m-0">Employee Benefits WhatsApp Chatbot</p>
          <div class="custom-row align-items-center flex-no-wrap w-100 justify-space-between mb-medium">
            <div class="w-40 custom-column align-items-center">
              <img src="assets/glyphs/new-design/instadesk/qr-code.png" alt="QR code" class="qr-code" />
            </div>
            <div class="custom-column row-gap-0 w-60 align-items-start">
              <p class="f-24 m-0 mb-small">Scan the QR code</p>
              <p class="f-24 m-0 mb-small bg-neutral-200 or p-x-small">or</p>
              <p class="f-24 m-0 mb-small">Save this number:</p>
              <p class="f-28 m-0 mb-small">+91 98218 72466</p>
              <p class="f-24 m-0 mb-small">to your contacts and type</p>
              <p class="f-28 m-0">"Hi" on WhatsApp</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
}
